import { FC, useState, createContext, useEffect, useReducer } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Nav from './pages/nav';
import Register from 'pages/register';
import Sentence from 'pages/sentence';
import CheckTest from 'pages/checktest';
import Overview from 'pages/overview';
import Writing from 'pages/writing';
import Mobile from 'pages/mobile';
import OpenAI from 'pages/openai';
import GPT4 from 'pages/gpt';

// Amplify ライブラリ関連
import Amplify from 'aws-amplify';
import awsconfig from 'aws-exports';
import { AmazonAIPredictionsProvider } from '@aws-amplify/predictions';
import { AuthState, onAuthUIStateChange } from '@aws-amplify/ui-components';
import { AmplifyAuthenticator, AmplifySignUp } from '@aws-amplify/ui-react';
import { appReducer, StateType, ActionType, initialState } from 'reducer';

// aws-exports.jsの読み込みを行う
Amplify.configure(awsconfig);
// AmplifyライブラリにAmazonAIPredictionProviderの機能を拡張する
Amplify.addPluggable(new AmazonAIPredictionsProvider());

type ContextType = {
  state: StateType;
  dispatch: React.Dispatch<ActionType>;
};

export const AppContext = createContext({} as ContextType);

type CognitoUser = {
  CognitoUser: {
    username: string;
  };
};

const App: FC = () => {
  const [authState, setAuthState] = useState<AuthState>();
  const [user, setUser] = useState<CognitoUser | undefined>();
  const [state, dispatch] = useReducer(appReducer, initialState);
  useEffect(() => {
    onAuthUIStateChange((nextAuthState, authData) => {
      setAuthState(nextAuthState);
      setUser(authData as CognitoUser);
    });
  }, []);
  const isPC = navigator.userAgent.match(/(Chrome|Firefox)/i);
  const isIpad = navigator.userAgent.match(/(iPad)/i) && !isPC;
  const isMobileMode = !isPC && !isIpad;
  return authState === AuthState.SignedIn && user ? (
    <>
      {/* 認証済みの場合はメインのコンポーネントを表示 */}
      <AppContext.Provider value={{ state, dispatch }}>
        {isMobileMode && (
          <>
            <Mobile />
          </>
        )}
        {!isMobileMode && (
          <Nav>
            <Switch>
              <Route exact path="/" component={Register} />
              <Route exact path="/register" component={Register} />
              <Route exact path="/sentence" component={Sentence} />
              <Route exact path="/checktest/:id" component={CheckTest} />
              <Route exact path="/overview" component={Overview} />
              <Route exact path="/writing" component={Writing} />
              <Route exact path="/openai" component={OpenAI} />
              <Route exact path="/chat" component={GPT4} />
              <Redirect to="/" />
            </Switch>
          </Nav>
        )}
      </AppContext.Provider>
    </>
  ) : (
    <>
      {/* 未認証の場合はメインのコンポーネントを表示 */}
      <AmplifyAuthenticator>
        <AmplifySignUp
          slot="sign-up"
          // SignUp時の設定要素に username、password、email を指定
          formFields={[
            { type: 'username' },
            { type: 'password' },
            { type: 'email' },
          ]}
        />
      </AmplifyAuthenticator>
    </>
  );
};
export default App;
